import { combineReducers } from "redux";
export const types = {
  SET_SUBJECT: "TRINITY/SET_SUBJECT",
  SET_PRE_SUBJECT: "TRINITY/SET_PRE_SUBJECT",
  SET_LEVEL: "TRINITY/SET_LEVEL",
  SET_PRE_LEVEL: "TRINITY/SET_PRE_LEVEL",
  SET_ERROR_TIP_VISIBLE: "TRINITY/SET_ERROR_TIP_VISIBLE",
  SET_STAT_INFO_VISIBLE: "TRINITY/SET_STAT_INFO_VISIBLE",
  SET_STAT_INFO: "TRINITY/SET_STAT_INFO",
  SET_CONFIRM_VISIBLE: "TRINITY/SET_CONFIRM_VISIBLE",
  SET_TIME: "TRINITY/SET_TIME",
};
const initialState = {
  wholeSubject: {
    政: "政治",
    史: "历史",
    地: "地理",
    物: "物理",
    化: "化学",
    生: "生物",
    技: "技术",
  },
  subjectCondition: [],
  preSubjectCondition: [],
  levelCondition: {
    语文: "",
    数学: "",
    外语: "",
    政治: "",
    历史: "",
    地理: "",
    物理: "",
    化学: "",
    生物: "",
    技术: "",
  },
  preLevelCondition: {
    语文: "",
    数学: "",
    外语: "",
    政治: "",
    历史: "",
    地理: "",
    物理: "",
    化学: "",
    生物: "",
    技术: "",
  },
  statInfo: {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
  },
  uiState: {
    errorTipVisible: false,
    errorTip: "",
    statInfoVisible: false,
    confirmVisible: false,
    time: 5,
  },
};

export const actions = {
  //设置三位一体的选考科目的条件
  setSubjectCondition: (subjectCondition) => {
    return {
      type: types.SET_SUBJECT,
      subjectCondition,
    };
  },
  //设置三位一体的选考科目的条件
  setPreSubjectCondition: (preSubjectCondition) => {
    return {
      type: types.SET_PRE_SUBJECT,
      preSubjectCondition,
    };
  },
  //设置学考等级的条件
  setLevelCondition: (levelCondition) => {
    return {
      type: types.SET_LEVEL,
      levelCondition,
    };
  },
  //设置学考等级的条件
  setPreLevelCondition: (preLevelCondition) => {
    return {
      type: types.SET_PRE_LEVEL,
      preLevelCondition,
    };
  },
  //设置是否显示错误提示
  setErrorTip: (errorTipVisible, errorTip) => {
    return {
      type: types.SET_ERROR_TIP_VISIBLE,
      errorTipVisible,
      errorTip,
    };
  },
  //设置统计信息的显示
  setStatInfoVisible: (statInfoVisible) => {
    return {
      type: types.SET_STAT_INFO_VISIBLE,
      statInfoVisible,
    };
  },
  //设置学考等级的统计信息
  setStatInfo: (statInfo) => {
    return {
      type: types.SET_STAT_INFO,
      statInfo,
    };
  },
  //设置三一条件的确认框是否显示和关闭
  setConfirmVisible: (confirmVisible) => {
    return {
      type: types.SET_CONFIRM_VISIBLE,
      confirmVisible,
    };
  },
  //设置确认按钮倒计时
  setTime: (time) => {
    return {
      type: types.SET_TIME,
      time,
    };
  },
};

//三一精灵的选考科目数据
const trinityData = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SUBJECT:
      return { ...state, subjectCondition: action.subjectCondition };
    case types.SET_PRE_SUBJECT:
      return { ...state, preSubjectCondition: action.preSubjectCondition };
    case types.SET_LEVEL:
      return { ...state, levelCondition: action.levelCondition };
    case types.SET_PRE_LEVEL:
      return { ...state, preLevelCondition: action.preLevelCondition };
    case types.SET_STAT_INFO:
      return { ...state, statInfo: action.statInfo };
    default:
      return { ...state };
  }
};

// 控制三一精灵弹出框的显示和关闭
const trinityUiData = (state = initialState.uiState, action) => {
  switch (action.type) {
    case types.SET_ERROR_TIP_VISIBLE:
      return {
        ...state,
        errorTipVisible: action.errorTipVisible,
        errorTip: action.errorTip,
      };
    case types.SET_STAT_INFO_VISIBLE:
      return {
        ...state,
        statInfoVisible: action.statInfoVisible,
      };
    case types.SET_CONFIRM_VISIBLE:
      return {
        ...state,
        confirmVisible: action.confirmVisible,
      };
    case types.SET_TIME:
      return {
        ...state,
        time: action.time,
      };
    default:
      return { ...state };
  }
};
const reducer = combineReducers({
  trinityUiData,
  trinityData,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/trinity.js